module.exports = __webpack_public_path__ + "static/media/3.5bc53457.png";